var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"causa-baixo-desempenho","rota-base":"/admin/causa-baixo-desempenho","titulo":"CAUSAS DE BAIXO DESEMPENHO","titulo-singular":"Causa de Baixo Desempenho","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }